import React from 'react';
import ServicePageTemplate from '../../../components/ServicePageTemplate/ServicePageTemplate';
import { getCategoryCatalog } from '../../../adapters/serviceCatalogAdapter';

const WeddingServicesPage = ({ onNavigate }) => {
  const catalog = getCategoryCatalog('wedding');

  return (
    <ServicePageTemplate
      serviceType="wedding"
      services={catalog.services}
      filters={catalog.filters}
      pageConfig={catalog.pageConfig}
      onNavigate={onNavigate}
    />
  );
};

export default WeddingServicesPage;

